import React from 'react';

const NotLoaded = (/* props */) => <span />;

export default NotLoaded;
